import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { BranchService } from 'src/app/services/branch.service';
import { Observable, BehaviorSubject, of, fromEvent } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { finalize, catchError, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { AccountService } from 'src/app/services/account.service';
import { DeleteBranchComponent } from './delete-branch/delete-branch.component';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-list-branches',
  templateUrl: './list-branches.component.html',
  styleUrls: ['./list-branches.component.css']
})
export class ListBranchesComponent implements OnInit, AfterViewInit {
   dataSource =  new BranchDataTableSource(this.branchService);
   tableFilters = '';
  branchCount: any;
  collapsed;
  displayedColumns = ['branchId', 'corpId', 'name', 'code', 'Email', 'regionalCode'];
  @ViewChild('go', {static: false}) button: ElementRef;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  data: any;
  selectedIndex = -1;
  showToolBar = false;
  loading = false;
  api_success: any;
  api_error: any;
  screenHeight;
  screenWidth;
  small_device_display = false;
  constructor(private branchService: BranchService, private router: Router, private activatedRoute: ActivatedRoute,
    private commonfilter: CommonfilterService, private accountService: AccountService, private dialog: MatDialog) {
      this.onResize();
     }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.data = params;
      this.tableFilters = 'corpId-eq=' + this.data.corporateId;
    this.dataSource.loadbranches(this.tableFilters, 'false', 0, 100);
    this.getTotalCountByFilters(this.tableFilters);
  });
  }
  getTotalCountByFilters(filters) {
    this.branchService.getTotalbranchCount(filters)
    .subscribe(res => {
      this.branchCount = res;
    });
  }
  goBacktoList() {
    this.router.navigate(['../list'], { relativeTo: this.activatedRoute });
  }
  ngAfterViewInit() {

    this.paginator.page
    .pipe(
        tap(() => this.loadBranchPage())
    )
    .subscribe();

    fromEvent(this.button.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
            this.tableFilters = this.commonfilter.createfilterParams('branch');
            this.getTotalCountByFilters(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadBranchPage();


        })
    )
    .subscribe();

}
onResize() {
  this.screenHeight = window.innerHeight;
  this.screenWidth = window.innerWidth;
  console.log(this.screenWidth);
  if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
    console.log(projectConstants.SMALL_DEVICE_BOUNDARY);
    console.log(this.screenWidth);
    this.small_device_display = true;
  } else {
    this.small_device_display = false;
  }
}
loadBranchPage() {
  const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;

  this.dataSource.loadbranches(

    this.tableFilters,
    'false',
    count,
    this.paginator.pageSize);
}
deleteBranch() {


  const deleteDialog = this.dialog.open(DeleteBranchComponent, {
    width: '800px',
     data : {'branchId': this.selectedIndex,'corpId': this.data.corporateId}
  });
  deleteDialog.afterClosed().subscribe( result => {


  });


}

onBranchClicked(row) {
  this.selectedIndex = row.id;
  this.showToolBar = true;

}

}
export class BranchDataTableSource implements DataSource<any> {
  private branchSubject = new BehaviorSubject<any>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private branchService: BranchService) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.branchSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.branchSubject.complete();
    this.loadingSubject.complete();
  }

 loadbranches( filter,
  sortDirection, count, pageSize) {

  this.loadingSubject.next(true);

  this.branchService.getBranches( filter, sortDirection,
    count, pageSize).pipe(
     catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
    .subscribe(branches => this.branchSubject.next(branches));
  }


}
